import { objectInitial } from "../../store/InitialStore";
import * as types from "../../actions/ActionTypes";
export default function HandleDocumentType(state = objectInitial, action) {
  const { type, payload } = action;
  switch (type) {
    case types.SET_DOCUMENT_TYPE:
      return { paymentsType: payload };
    default:
      return state;
  }
}
